export { GoogleTagManager, type GoogleTagManagerId } from './GoogleTagManager';
